import { KemConsentFormControllerService } from "@ch/generated/services/KemConsentFormControllerService";
import { handleError } from "@ch/helpers/utils/handleError";
import { NotifySuccess } from "@ch/helpers/utils/helpers";
import type { AppState } from "@ch/redux-store/root-reducer";
import { AppRoutesEnum } from "@ch/router/AppRoutes/enums";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useResendConsentEmail = () => {
  const userId = useSelector((s: AppState) => s.user.currentUser?.id);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const sendReminder = useCallback(async () => {
    if (!userId) {
      handleError(new Error("User ID not found"), undefined, true);
      return;
    }

    setIsLoading(true);
    try {
      await KemConsentFormControllerService.kemConsentFormControllerResendEmail(
        { userId },
      );
      NotifySuccess("Reminder sent successfully to your parent/guardian");
      await navigate(AppRoutesEnum.ROOT);
    } catch (error) {
      handleError(error, undefined, true);
    } finally {
      setIsLoading(false);
    }
  }, [userId, navigate]);

  return {
    sendReminder,
    isLoading,
  };
};

export default useResendConsentEmail;
